import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    markButtons: {
      padding: theme.spacing(0.5, 1.25),
      fontSize: `small`,
      whiteSpace: 'wrap',
      lineHeight: 1,
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      flexWrap: 'nowrap',
      gap: theme.spacing(1),
    },
    buttonContainerCompact: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      flexWrap: 'wrap',
      gap: theme.spacing(1),
    },
  };
};
